import React, { useState } from 'react';
    import { Loader2 } from 'lucide-react';
    import { apiService } from '../service/Api';
    import { useAuth } from '../context/AuthContext';
    import { GoogleLogin } from '@react-oauth/google';
    import { useNavigate } from 'react-router-dom';

const CompanyLogo = () => (
  <div className="flex items-center justify-center mb-8">
    <img 
      src="https://i.ibb.co/MvVKzjj/file-00000000a5dc7209bf802deb262dc9a8.png"
      alt="Company Logo"
      className="h-16 w-auto"
      onError={(e) => {
        // Fallback if image fails to load
        e.target.style.display = 'none';
      }}
    />
  </div>
);



// Main App Component
export default function App() {
    const { isInExtension, login } = useAuth();
    const navigate = useNavigate();

console.log("isInExtension", isInExtension);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

// also get rhe url form the url 



  // Get url from parms
  const url = new URLSearchParams(window.location.search).get('url');
  console.log("url", url);

  const completeParentUrl = url;  

 
  console.log("Complete parent URL:", completeParentUrl);

  
  const currentUrl = window.location;
  console.log("Current URL:", currentUrl);
  
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      setLoading(true);
      setError('');
      const res = await apiService.googleLogin(credentialResponse.credential);
      console.log("Google Login Response", res);
      
      if (res.data.success) {
          const { token, user, tenant_id } = res.data;
          
          // Store tenant_id
          if (tenant_id) {
             localStorage.setItem('aura_tenant_id', tenant_id);
             apiService.setTenantId(tenant_id);
          }
          
          // Store token
          localStorage.setItem('aura_token', token);
          apiService.setAuthToken(token);

          // Update Context
          login(token, user);

          // Redirect
          // if(isInExtension && url){
          //     console.log("Redirecting to Deal Insights with URL:", url);
          //     navigate(`/deal-insights?url=${encodeURIComponent(url)}`);
          // } else {
          //     console.log("Redirecting to Tailspin Dashboard");
          //     navigate('/tailspin/dashboard');
          // }


       if(isInExtension && !url){
        // navigate to / route 
        console.log("Redirecting to Home");
        navigate('/');
       }
          if(isInExtension && url ){
            console.log("Redirecting to Deal Insights with URL:", url);
            navigate(`/deal-insights?url=${encodeURIComponent(url)}`);
        } else {
            console.log("Redirecting to Tailspin Dashboard");
            navigate('/tailspin/dashboard');
        }
      }
    } catch (err) {
      console.error("Google Login Error", err);
      setError(err.response?.data?.error || "Google Login Failed");
    } finally {
      setLoading(false);
    }
  };


  // --- Render Logic ---
  return (
    <div className="min-h-screen font-sans antialiased" style={{ backgroundColor: '#F8F7F4' }}>
      <div className="flex min-h-screen flex-col items-center justify-center p-4">
        <div className="w-full max-w-sm">
          {/* Header Section with Logo */}
          <header className="text-center">
            <CompanyLogo />
          </header>

          {/* Main Card */}
          <div className="rounded-xl border shadow-lg" style={{ backgroundColor: '#FFFFFF', borderColor: '#D7B472' }}>
              {/* --- Sign-in View --- */}
              <div className="p-6 sm:p-8">
                <div className="text-center mb-8">
                  <h2 className="text-2xl font-bold tracking-tight" style={{ color: '#0A0A10' }}>Welcome Back</h2>
                  <p className="mt-1" style={{ color: '#0A0A10', opacity: 0.7 }}>
                    Sign in to your workspace
                  </p>
                </div>

                <div className="flex flex-col items-center space-y-6">
                  {/* Google Login Button */}
                  <div className="w-full flex justify-center">
                    <GoogleLogin
                        onSuccess={handleGoogleSuccess}
                        onError={() => {
                            console.log('Login Failed');
                            setError('Google Login Failed');
                        }}
                        useOneTap
                        theme="filled_blue"
                        shape="pill"
                        width="100%"
                    />
                  </div>

                  {/* Error Message */}
                  {error && <p className="text-sm text-center" style={{ color: '#FF6B5A' }}>{error}</p>}
                  
                  {loading && (
                      <div className="flex items-center justify-center text-sm text-gray-500">
                          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                          Logging in...
                      </div>
                  )}

                </div>
              </div>
          </div>

          {/* Footer */}
          <footer className="mt-8 text-center text-sm" style={{ color: '#0A0A10', opacity: 0.6 }}>
            <p>&copy; {new Date().getFullYear()} All rights reserved.</p>
          </footer>
        </div>
      </div>
    </div>
  );
}
